import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { Helmet } from 'react-helmet';

import './PromoBanner.style.scss';

/** @namespace Pwa/Component/PromoBanner/Component */
export class PromoBanner extends PureComponent {
    static propTypes = {
        banners: PropTypes.array,
    };

    getScriptFromString(content) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const scripts = doc.querySelectorAll('script');
        const scriptsArray = [];

        for (let i = 0; i < scripts.length; i++) {
            if (scripts[i].innerHTML && scripts[i].innerHTML !== '') {
                scriptsArray.push(<script>{scripts[i].innerHTML}</script>);
            }
        }

        return scriptsArray;
    }

    render() {
        const { banners, section, categoryId, productId } = this.props;

        if (!banners.length) {
            return null;
        }

        return banners.map(({ content, url }, index) => {
            const catId = `_${categoryId}` || '';
            const prodId = `_${productId}` || '';
            const jsScripts = this.getScriptFromString(content);

            return (
                <div
                    block="PromoBanner"
                    elem="Banner"
                    key={`promobanner_${section}${index}${catId}${prodId}`}
                    mods={{ isClickable: !!url }}
                >
                    <Helmet>{jsScripts}</Helmet>
                    <div
                        onClick={() => {
                            if (url) {
                                window.location.href = url;
                            }
                        }}
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                </div>
            );
        });
    }
}

export default PromoBanner;
